import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnDK: CultureInfo = {
  name: 'en-DK',
  displayName: 'English (Denmark)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-DK',
  parent: CultureInfoEn
};
